import { fragmentModuleNavigationLink } from '#layers/core/data-layer/modules/fragments'
import { gql } from 'graphql-tag'

export default gql`
  ${fragmentModuleNavigationLink}
  fragment BlockCampaignsCallToActionFragment on BlockCampaignsCallToAction {
    sys {
      id
    }
    title
    description
    link {
      ...ModuleNavigationLinkFragment
    }
    icon
  }
`
